const pageNameKey = "serverError";

export const serverErrorPageEn = {
  [pageNameKey]: {
    hintTitle:
      "We're having difficulties connecting to the server, please try again later.",
    title: "Failed to load content ...",
    button: "Refresh",
  },
};

export const serverErrorPagePtBr = {
  [pageNameKey]: {
    hintTitle:
      "Estamos com dificuldades para nos conectar ao servidor. Tente novamente mais tarde.",
    title: "Falha ao carregar o conteúdo...",
    button: "Atualizar",
  },
};

export const serverErrorPageDe = {
  [pageNameKey]: {
    hintTitle:
      "Wir haben Schwierigkeiten, uns mit dem Server zu verbinden, bitte versuchen Sie es später noch einmal.",
    title: "Inhalt konnte nicht geladen werden ...",
    button: "Aktualisieren",
  },
};

export const serverErrorPageZhHans = {
  [pageNameKey]: {
    hintTitle: "我们在连接服务器时遇到困难，请稍后再试。",
    title: "内容加载失败...",
    button: "刷新",
  },
};

export const serverErrorPageIt = {
  [pageNameKey]: {
    hintTitle:
      "Stiamo riscontrando difficoltà a connetterci al server, riprova più tardi.",
    title: "Impossibile caricare il contenuto ...",
    button: "Aggiorna",
  },
};

export const serverErrorPageEs = {
  [pageNameKey]: {
    hintTitle:
      "Estamos teniendo dificultades para conectarnos al servidor, por favor inténtalo de nuevo más tarde.",
    title: "No se pudo cargar el contenido ...",
    button: "Actualizar",
  },
};

export const serverErrorPageNl = {
  [pageNameKey]: {
    hintTitle:
      "We hebben moeite om verbinding te maken met de server, probeer het later opnieuw.",
    title: "Laden van inhoud mislukt ...",
    button: "Vernieuwen",
  },
};

export const serverErrorPageTr = {
  [pageNameKey]: {
    button: "Yenile",
    hintTitle:
      "Sunucuya bağlanırken sorun yaşıyoruz, lütfen daha sonra tekrar deneyin.",
    title: "İçerik yüklenemedi...",
  },
};
